import {EmailCodeInput as CodeInput} from '@guestapp/ui';
import {VerificationSection, VerificationTitle, VerificationSubtitle} from './styled';

type Props = {
  title: string;
  subtitle: string;
  value: string;
  onChange: (value: string) => void;
  errorMessage?: string;
  length?: number;
  className?: string;
};

const CodeVerificationSection = ({
  title,
  subtitle,
  value,
  onChange,
  errorMessage,
  length = 6,
  className,
}: Props) => {
  return (
    <VerificationSection className={className}>
      <div>
        <VerificationTitle>{title}</VerificationTitle>
        <VerificationSubtitle>{subtitle}</VerificationSubtitle>
      </div>
      <CodeInput
        value={value}
        onChange={onChange}
        length={length}
        errorMessage={errorMessage}
      />
    </VerificationSection>
  );
};

export {CodeVerificationSection};
